import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import ConstantDryMassDeterminationMultiTraySection from './ConstantDryMassDeterminationMultiTraySection';
import ConstantDryMassDeterminationSingleTraySection from './ConstantDryMassDeterminationSingleTraySection';

let ConstantDryMassDeterminationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const singleTray = useSelector(pipe(createWorksheetSelector!('DryingTrays'), (p) => p === undefined || p.length < 2));

  return (
    <>
      {singleTray ? (
        <ConstantDryMassDeterminationSingleTraySection />
      ) : (
        <ConstantDryMassDeterminationMultiTraySection />
      )}

      <ListFieldSection>
        <Field input={<TextOutput />} name="Measurements.TotalDryMass" />
      </ListFieldSection>
    </>
  );
};

ConstantDryMassDeterminationSection = withInjectedProps(ConstantDryMassDeterminationSection);

export { ConstantDryMassDeterminationSection };
export default ConstantDryMassDeterminationSection;
